import { Component, inject, OnInit } from '@angular/core';

import { ModalService } from 'app/services/modal.service';
import { TagStore } from '../../store/tag/tag.store';
import { VehicleStore } from '../../store/vehicle/vehicle.store';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectProfileData } from 'app/store/me/me.selectors';
import { User } from '@kinomap-dev/ng-ui-lib';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-browse',
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.scss'],
  standalone: true,
  imports: [RouterOutlet, ModalComponent],
})
export class BrowseComponent implements OnInit {
  public modalService: ModalService = inject(ModalService);
  private vehicleStore: VehicleStore = inject(VehicleStore);
  private store: Store = inject(Store);

  subscription: Subscription;

  ngOnInit(): void {
    this.vehicleStore.getVehicles();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
